function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { Plugin as k, Command as z } from "../../../../../@ckeditor_ckeditor5-core@45.2.1/node_modules/@ckeditor/ckeditor5-core/dist/index.js";
import { keyCodes as y, ObservableMixin as V, env as E, count as Y, isInsideSurrogatePair as J, isInsideCombinedSymbol as X, isInsideEmojiSequence as Z, EventInfo as ee } from "../../../../../@ckeditor_ckeditor5-utils@45.2.1/node_modules/@ckeditor/ckeditor5-utils/dist/index.js";
import { _tryFixingModelRange as $, BubblingEventInfo as D, DomEventData as S, Observer as W, MouseObserver as te, TouchObserver as ne, LiveRange as ie, FocusObserver as se } from "../../../../../@ckeditor_ckeditor5-engine@45.2.1/node_modules/@ckeditor/ckeditor5-engine/dist/index.js";
import { escapeRegExp as oe } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/string/escapeRegExp.js";
import { debounce as re } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/function/debounce.js"; /**
                                                                                                                            * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                            * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                            */ /**
                                                                                                                               * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                               * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                               */
var U = /*#__PURE__*/function () {
  function U(e) {
    var _this = this;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    _classCallCheck(this, U);
    _defineProperty(this, "model", void 0);
    _defineProperty(this, "limit", void 0);
    _defineProperty(this, "_isLocked", void 0);
    _defineProperty(this, "_size", void 0);
    _defineProperty(this, "_batch", null);
    _defineProperty(this, "_changeCallback", void 0);
    _defineProperty(this, "_selectionChangeCallback", void 0);
    this.model = e, this._size = 0, this.limit = t, this._isLocked = !1, this._changeCallback = function (n, s) {
      s.isLocal && s.isUndoable && s !== _this._batch && _this._reset(!0);
    }, this._selectionChangeCallback = function () {
      _this._reset();
    }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
  }
  return _createClass(U, [{
    key: "batch",
    get: function get() {
      return this._batch || (this._batch = this.model.createBatch({
        isTyping: !0
      })), this._batch;
    }
  }, {
    key: "size",
    get: function get() {
      return this._size;
    }
  }, {
    key: "input",
    value: function input(e) {
      this._size += e, this._size >= this.limit && this._reset(!0);
    }
  }, {
    key: "isLocked",
    get: function get() {
      return this._isLocked;
    }
  }, {
    key: "lock",
    value: function lock() {
      this._isLocked = !0;
    }
  }, {
    key: "unlock",
    value: function unlock() {
      this._isLocked = !1;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
    }
  }, {
    key: "_reset",
    value: function _reset() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      (!this.isLocked || e) && (this._batch = null, this._size = 0);
    }
  }]);
}();
var ce = /*#__PURE__*/function (_z) {
  function ce(e, t) {
    var _this2;
    _classCallCheck(this, ce);
    _this2 = _callSuper(this, ce, [e]), _defineProperty(_assertThisInitialized(_this2), "_buffer", void 0), _this2._buffer = new U(e.model, t), _this2._isEnabledBasedOnSelection = !1;
    return _this2;
  }
  _inherits(ce, _z);
  return _createClass(ce, [{
    key: "buffer",
    get: function get() {
      return this._buffer;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(ce, "destroy", this, 3)([]), this._buffer.destroy();
    }
  }, {
    key: "execute",
    value: function execute() {
      var _this3 = this;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = this.editor.model,
        n = t.document,
        s = e.text || "",
        i = s.length;
      var c = n.selection;
      if (e.selection ? c = e.selection : e.range && (c = t.createSelection(e.range)), !t.canEditAt(c)) return;
      var r = e.resultRange;
      t.enqueueChange(this._buffer.batch, function (l) {
        _this3._buffer.lock();
        var a = Array.from(n.selection.getAttributes());
        t.deleteContent(c), s && t.insertContent(l.createText(s, a), c), r ? l.setSelection(r) : c.is("documentSelection") || l.setSelection(c), _this3._buffer.unlock(), _this3._buffer.input(i);
      });
    }
  }]);
}(z);
var Q = ["insertText", "insertReplacementText"],
  le = [].concat(Q, ["insertCompositionText"]);
var ae = /*#__PURE__*/function (_W) {
  function ae(e) {
    var _this4;
    _classCallCheck(this, ae);
    _this4 = _callSuper(this, ae, [e]), _defineProperty(_assertThisInitialized(_this4), "focusObserver", void 0), _this4.focusObserver = e.getObserver(se);
    var t = E.isAndroid ? le : Q,
      n = e.document;
    n.on("beforeinput", function (s, i) {
      if (!_this4.isEnabled) return;
      var c = i.data,
        r = i.targetRanges,
        l = i.inputType,
        a = i.domEvent,
        u = i.isComposing;
      if (!t.includes(l)) return;
      _this4.focusObserver.flush();
      var d = new ee(n, "insertText");
      n.fire(d, new S(e, a, {
        text: c,
        selection: e.createSelection(r),
        isComposing: u
      })), d.stop.called && s.stop();
    }), E.isAndroid || n.on("compositionend", function (s, _ref) {
      var i = _ref.data,
        c = _ref.domEvent;
      _this4.isEnabled && i && n.fire("insertText", new S(e, c, {
        text: i,
        isComposing: !0
      }));
    }, {
      priority: "low"
    });
    return _this4;
  }
  _inherits(ae, _W);
  return _createClass(ae, [{
    key: "observe",
    value: function observe() {}
  }, {
    key: "stopObserving",
    value: function stopObserving() {}
  }]);
}(W);
var ue = /*#__PURE__*/function (_k) {
  function ue() {
    var _this5;
    _classCallCheck(this, ue);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this5 = _callSuper(this, ue, [].concat(args));
    _defineProperty(_this5, "_typingQueue", void 0);
    return _this5;
  }
  _inherits(ue, _k);
  return _createClass(ue, [{
    key: "init",
    value: function init() {
      var _this6 = this;
      var e = this.editor,
        t = e.model,
        n = e.editing.view,
        s = e.editing.mapper,
        i = t.document.selection;
      this._typingQueue = new de(e), n.addObserver(ae);
      var c = new ce(e, e.config.get("typing.undoStep") || 20);
      e.commands.add("insertText", c), e.commands.add("input", c), this.listenTo(n.document, "beforeinput", function () {
        _this6._typingQueue.flush("next beforeinput");
      }, {
        priority: "high"
      }), this.listenTo(n.document, "insertText", function (r, l) {
        var a = l.text,
          u = l.selection;
        if (n.document.selection.isFake && u && n.document.selection.isSimilar(u) && l.preventDefault(), u && Array.from(u.getRanges()).some(function (f) {
          return !f.isCollapsed;
        }) && l.preventDefault(), !c.isEnabled) {
          l.preventDefault();
          return;
        }
        var d;
        u ? d = Array.from(u.getRanges()).map(function (f) {
          return s.toModelRange(f);
        }).map(function (f) {
          return $(f, t.schema) || f;
        }) : d = Array.from(i.getRanges());
        var h = a;
        if (E.isAndroid) {
          var f = Array.from(d[0].getItems()).reduce(function (b, v) {
            return b + (v.is("$textProxy") ? v.data : "");
          }, "");
          if (f && (f.length <= h.length ? h.startsWith(f) && (h = h.substring(f.length), d[0].start = d[0].start.getShiftedBy(f.length)) : f.startsWith(h) && (d[0].start = d[0].start.getShiftedBy(h.length), h = "")), h.length == 0 && d[0].isCollapsed) return;
        }
        var g = {
          text: h,
          selection: t.createSelection(d)
        };
        _this6._typingQueue.push(g, !!l.isComposing), l.domEvent.defaultPrevented && _this6._typingQueue.flush("beforeinput default prevented");
      }), E.isAndroid ? this.listenTo(n.document, "keydown", function (r, l) {
        i.isCollapsed || l.keyCode != 229 || !n.document.isComposing || F(t, c);
      }) : this.listenTo(n.document, "compositionstart", function () {
        i.isCollapsed || F(t, c);
      }, {
        priority: "high"
      }), this.listenTo(n.document, "mutations", function (r, _ref2) {
        var l = _ref2.mutations;
        if (_this6._typingQueue.hasAffectedElements()) {
          var _iterator = _createForOfIteratorHelper(l),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _ref3 = _step.value;
              var a = _ref3.node;
              var u = he(a, s),
                d = s.toModelElement(u);
              if (_this6._typingQueue.isElementAffected(d)) {
                _this6._typingQueue.flush("mutations");
                return;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }), this.listenTo(n.document, "compositionend", function () {
        _this6._typingQueue.flush("before composition end");
      }, {
        priority: "high"
      }), this.listenTo(n.document, "compositionend", function () {
        _this6._typingQueue.flush("after composition end");
        var r = [];
        if (_this6._typingQueue.hasAffectedElements()) {
          var _iterator2 = _createForOfIteratorHelper(_this6._typingQueue.flushAffectedElements()),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var l = _step2.value;
              var a = s.toViewElement(l);
              a && r.push({
                type: "children",
                node: a
              });
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        (r.length || !E.isAndroid) && n.document.fire("mutations", {
          mutations: r
        });
      }, {
        priority: "lowest"
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(ue, "destroy", this, 3)([]), this._typingQueue.destroy();
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "Input";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(k);
var de = /*#__PURE__*/function () {
  function de(e) {
    var _this7 = this;
    _classCallCheck(this, de);
    _defineProperty(this, "editor", void 0);
    _defineProperty(this, "flushDebounced", re(function () {
      return _this7.flush("timeout");
    }, 50));
    _defineProperty(this, "_queue", []);
    _defineProperty(this, "_isComposing", !1);
    _defineProperty(this, "_affectedElements", new Set());
    this.editor = e;
  }
  return _createClass(de, [{
    key: "destroy",
    value: function destroy() {
      for (this.flushDebounced.cancel(), this._affectedElements.clear(); this._queue.length;) this.shift();
    }
  }, {
    key: "length",
    get: function get() {
      return this._queue.length;
    }
  }, {
    key: "push",
    value: function push(e, t) {
      var n = {
        text: e.text
      };
      if (e.selection) {
        n.selectionRanges = [];
        var _iterator3 = _createForOfIteratorHelper(e.selection.getRanges()),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var s = _step3.value;
            n.selectionRanges.push(ie.fromRange(s)), this._affectedElements.add(s.start.parent);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      this._queue.push(n), this._isComposing || (this._isComposing = t), this.flushDebounced();
    }
  }, {
    key: "shift",
    value: function shift() {
      var e = this._queue.shift(),
        t = {
          text: e.text
        };
      if (e.selectionRanges) {
        var n = e.selectionRanges.map(function (s) {
          return fe(s);
        }).filter(function (s) {
          return !!s;
        });
        n.length && (t.selection = this.editor.model.createSelection(n));
      }
      return t;
    }
  }, {
    key: "flush",
    value: function flush(e) {
      var _this8 = this;
      var t = this.editor,
        n = t.model,
        s = t.editing.view;
      if (this.flushDebounced.cancel(), !this._queue.length) return;
      var c = t.commands.get("insertText").buffer;
      n.enqueueChange(c.batch, function () {
        for (c.lock(); _this8._queue.length;) {
          var r = _this8.shift();
          t.execute("insertText", r);
        }
        c.unlock(), _this8._isComposing || _this8._affectedElements.clear(), _this8._isComposing = !1;
      }), s.scrollToTheSelection();
    }
  }, {
    key: "isElementAffected",
    value: function isElementAffected(e) {
      return this._affectedElements.has(e);
    }
  }, {
    key: "hasAffectedElements",
    value: function hasAffectedElements() {
      return this._affectedElements.size > 0;
    }
  }, {
    key: "flushAffectedElements",
    value: function flushAffectedElements() {
      var e = Array.from(this._affectedElements);
      return this._affectedElements.clear(), e;
    }
  }]);
}();
function F(o, e) {
  if (!e.isEnabled) return;
  var t = e.buffer;
  t.lock(), o.enqueueChange(t.batch, function () {
    o.deleteContent(o.document.selection);
  }), t.unlock();
}
function fe(o) {
  var e = o.toRange();
  return o.detach(), e.root.rootName == "$graveyard" ? null : e;
}
function he(o, e) {
  var t = o.is("$text") ? o.parent : o;
  for (; !e.toModelElement(t);) t = t.parent;
  return t;
}
var I = /*#__PURE__*/function (_z2) {
  function I(e, t) {
    var _this9;
    _classCallCheck(this, I);
    _this9 = _callSuper(this, I, [e]), _defineProperty(_assertThisInitialized(_this9), "direction", void 0), _defineProperty(_assertThisInitialized(_this9), "_buffer", void 0), _this9.direction = t, _this9._buffer = new U(e.model, e.config.get("typing.undoStep")), _this9._isEnabledBasedOnSelection = !1;
    return _this9;
  }
  _inherits(I, _z2);
  return _createClass(I, [{
    key: "buffer",
    get: function get() {
      return this._buffer;
    }
  }, {
    key: "execute",
    value: function execute() {
      var _this0 = this;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = this.editor.model,
        n = t.document;
      t.enqueueChange(this._buffer.batch, function (s) {
        _this0._buffer.lock();
        var i = s.createSelection(e.selection || n.selection);
        if (!t.canEditAt(i)) return;
        var c = e.sequence || 1,
          r = i.isCollapsed;
        if (i.isCollapsed && t.modifySelection(i, {
          direction: _this0.direction,
          unit: e.unit,
          treatEmojiAsSingleUnit: !0
        }), _this0._shouldEntireContentBeReplacedWithParagraph(c)) {
          _this0._replaceEntireContentWithParagraph(s);
          return;
        }
        if (_this0._shouldReplaceFirstBlockWithParagraph(i, c)) {
          _this0.editor.execute("paragraph", {
            selection: i
          });
          return;
        }
        if (i.isCollapsed) return;
        var l = 0;
        i.getFirstRange().getMinimalFlatRanges().forEach(function (a) {
          l += Y(a.getWalker({
            singleCharacters: !0,
            ignoreElementEnd: !0,
            shallow: !0
          }));
        }), t.deleteContent(i, {
          doNotResetEntireContent: r,
          direction: _this0.direction
        }), _this0._buffer.input(l), s.setSelection(i), _this0._buffer.unlock();
      });
    }
  }, {
    key: "_shouldEntireContentBeReplacedWithParagraph",
    value: function _shouldEntireContentBeReplacedWithParagraph(e) {
      if (e > 1) return !1;
      var t = this.editor.model,
        s = t.document.selection,
        i = t.schema.getLimitElement(s);
      if (!(s.isCollapsed && s.containsEntireContent(i)) || !t.schema.checkChild(i, "paragraph")) return !1;
      var r = i.getChild(0);
      return !(r && r.is("element", "paragraph"));
    }
  }, {
    key: "_replaceEntireContentWithParagraph",
    value: function _replaceEntireContentWithParagraph(e) {
      var t = this.editor.model,
        s = t.document.selection,
        i = t.schema.getLimitElement(s),
        c = e.createElement("paragraph");
      e.remove(e.createRangeIn(i)), e.insert(c, i), e.setSelection(c, 0);
    }
  }, {
    key: "_shouldReplaceFirstBlockWithParagraph",
    value: function _shouldReplaceFirstBlockWithParagraph(e, t) {
      var n = this.editor.model;
      if (t > 1 || this.direction != "backward" || !e.isCollapsed) return !1;
      var s = e.getFirstPosition(),
        i = n.schema.getLimitElement(s),
        c = i.getChild(0);
      return !(s.parent != c || !e.containsEntireContent(c) || !n.schema.checkChild(i, "paragraph") || c.name == "paragraph");
    }
  }]);
}(z);
var me = "character",
  L = "word",
  ge = "codePoint",
  _ = "selection",
  C = "backward",
  A = "forward",
  j = {
    deleteContent: {
      unit: _,
      direction: C
    },
    deleteContentBackward: {
      unit: ge,
      direction: C
    },
    deleteWordBackward: {
      unit: L,
      direction: C
    },
    deleteHardLineBackward: {
      unit: _,
      direction: C
    },
    deleteSoftLineBackward: {
      unit: _,
      direction: C
    },
    deleteContentForward: {
      unit: me,
      direction: A
    },
    deleteWordForward: {
      unit: L,
      direction: A
    },
    deleteHardLineForward: {
      unit: _,
      direction: A
    },
    deleteSoftLineForward: {
      unit: _,
      direction: A
    }
  };
var pe = /*#__PURE__*/function (_W2) {
  function pe(e) {
    var _this1;
    _classCallCheck(this, pe);
    _this1 = _callSuper(this, pe, [e]);
    var t = e.document;
    var n = 0;
    t.on("keydown", function () {
      n++;
    }), t.on("keyup", function () {
      n = 0;
    }), t.on("beforeinput", function (s, i) {
      if (!_this1.isEnabled) return;
      var c = i.targetRanges,
        r = i.domEvent,
        l = i.inputType,
        a = j[l];
      if (!a) return;
      var u = {
        direction: a.direction,
        unit: a.unit,
        sequence: n
      };
      u.unit == _ && (u.selectionToRemove = e.createSelection(c[0])), l === "deleteContentBackward" && (E.isAndroid && (u.sequence = 1), _e(c) && (u.unit = _, u.selectionToRemove = e.createSelection(c)));
      var d = new D(t, "delete", c[0]);
      t.fire(d, new S(e, r, u)), d.stop.called && s.stop();
    }), E.isBlink && be(_this1);
    return _this1;
  }
  _inherits(pe, _W2);
  return _createClass(pe, [{
    key: "observe",
    value: function observe() {}
  }, {
    key: "stopObserving",
    value: function stopObserving() {}
  }]);
}(W);
function be(o) {
  var e = o.view,
    t = e.document;
  var n = null,
    s = !1;
  t.on("keydown", function (r, _ref4) {
    var l = _ref4.keyCode;
    n = l, s = !1;
  }), t.on("keyup", function (r, _ref5) {
    var l = _ref5.keyCode,
      a = _ref5.domEvent;
    var u = t.selection,
      d = o.isEnabled && l == n && i(l) && !u.isCollapsed && !s;
    if (n = null, d) {
      var h = u.getFirstRange(),
        g = new D(t, "delete", h),
        f = {
          unit: _,
          direction: c(l),
          selectionToRemove: u
        };
      t.fire(g, new S(e, a, f));
    }
  }), t.on("beforeinput", function (r, _ref6) {
    var l = _ref6.inputType;
    var a = j[l];
    i(n) && a && a.direction == c(n) && (s = !0);
  }, {
    priority: "high"
  }), t.on("beforeinput", function (r, _ref7) {
    var l = _ref7.inputType,
      a = _ref7.data;
    n == y.delete && l == "insertText" && a == "" && r.stop();
  }, {
    priority: "high"
  });
  function i(r) {
    return r == y.backspace || r == y.delete;
  }
  function c(r) {
    return r == y.backspace ? C : A;
  }
}
function _e(o) {
  if (o.length != 1 || o[0].isCollapsed) return !1;
  var e = o[0].getWalker({
    direction: "backward",
    singleCharacters: !0,
    ignoreElementEnd: !0
  });
  var t = 0;
  var _iterator4 = _createForOfIteratorHelper(e),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _ref8 = _step4.value;
      var n = _ref8.nextPosition;
      var s = _ref8.item;
      if (n.parent.is("$text")) {
        var i = n.parent.data,
          c = n.offset;
        if (J(i, c) || X(i, c) || Z(i, c)) continue;
        t++;
      } else (s.is("containerElement") || s.is("emptyElement")) && t++;
      if (t > 1) return !0;
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return !1;
}
var ve = /*#__PURE__*/function (_k2) {
  function ve() {
    var _this10;
    _classCallCheck(this, ve);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this10 = _callSuper(this, ve, [].concat(args));
    _defineProperty(_this10, "_undoOnBackspace", void 0);
    return _this10;
  }
  _inherits(ve, _k2);
  return _createClass(ve, [{
    key: "init",
    value: function init() {
      var _this11 = this;
      var e = this.editor,
        t = e.editing.view,
        n = t.document,
        s = e.model.document;
      t.addObserver(pe), this._undoOnBackspace = !1;
      var i = new I(e, "forward");
      e.commands.add("deleteForward", i), e.commands.add("forwardDelete", i), e.commands.add("delete", new I(e, "backward")), this.listenTo(n, "delete", function (c, r) {
        n.isComposing || r.preventDefault();
        var l = r.direction,
          a = r.sequence,
          u = r.selectionToRemove,
          d = r.unit,
          h = l === "forward" ? "deleteForward" : "delete",
          g = {
            sequence: a
          };
        if (d == "selection") {
          var f = Array.from(u.getRanges()).map(function (b) {
            return e.editing.mapper.toModelRange(b);
          }).map(function (b) {
            return $(b, e.model.schema) || b;
          });
          g.selection = e.model.createSelection(f);
        } else g.unit = d;
        e.execute(h, g), t.scrollToTheSelection();
      }, {
        priority: "low"
      }), this.listenTo(n, "keydown", function (c, r) {
        if (n.isComposing || r.keyCode != y.backspace || !s.selection.isCollapsed) return;
        var l = e.model.schema.getLimitElement(s.selection),
          a = e.model.createPositionAt(l, 0);
        if (a.isTouching(s.selection.getFirstPosition())) {
          r.preventDefault();
          var u = e.model.schema.getNearestSelectionRange(a, "forward");
          if (!u) return;
          var d = t.createSelection(e.editing.mapper.toViewRange(u)),
            h = d.getFirstRange(),
            g = new D(document, "delete", h),
            f = {
              unit: "selection",
              direction: "backward",
              selectionToRemove: d
            };
          n.fire(g, new S(t, r.domEvent, f));
        }
      }), this.editor.plugins.has("UndoEditing") && (this.listenTo(n, "delete", function (c, r) {
        _this11._undoOnBackspace && r.direction == "backward" && r.sequence == 1 && r.unit == "codePoint" && (_this11._undoOnBackspace = !1, e.execute("undo"), r.preventDefault(), c.stop());
      }, {
        context: "$capture"
      }), this.listenTo(s, "change", function () {
        _this11._undoOnBackspace = !1;
      }));
    }
  }, {
    key: "requestUndoOnBackspace",
    value: function requestUndoOnBackspace() {
      this.editor.plugins.has("UndoEditing") && (this._undoOnBackspace = !0);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "Delete";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(k);
var Fe = /*#__PURE__*/function (_k3) {
  function Fe() {
    _classCallCheck(this, Fe);
    return _callSuper(this, Fe, arguments);
  }
  _inherits(Fe, _k3);
  return _createClass(Fe, null, [{
    key: "requires",
    get: function get() {
      return [ue, ve];
    }
  }, {
    key: "pluginName",
    get: function get() {
      return "Typing";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(k);
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function ye(o, e) {
  var t = o.start;
  return {
    text: Array.from(o.getWalker({
      ignoreElementEnd: !1
    })).reduce(function (s, _ref9) {
      var i = _ref9.item;
      return i.is("$text") || i.is("$textProxy") ? s + i.data : (t = e.createPositionAfter(i), "");
    }, ""),
    range: e.createRange(t, o.end)
  };
}
var Ee = /*#__PURE__*/function (_V) {
  function Ee(e, t) {
    var _this12;
    _classCallCheck(this, Ee);
    _this12 = _callSuper(this, Ee), _defineProperty(_assertThisInitialized(_this12), "model", void 0), _defineProperty(_assertThisInitialized(_this12), "testCallback", void 0), _defineProperty(_assertThisInitialized(_this12), "_hasMatch", void 0), _this12.model = e, _this12.testCallback = t, _this12._hasMatch = !1, _this12.set("isEnabled", !0), _this12.on("change:isEnabled", function () {
      _this12.isEnabled ? _this12._startListening() : (_this12.stopListening(e.document.selection), _this12.stopListening(e.document));
    }), _this12._startListening();
    return _this12;
  }
  _inherits(Ee, _V);
  return _createClass(Ee, [{
    key: "hasMatch",
    get: function get() {
      return this._hasMatch;
    }
  }, {
    key: "_startListening",
    value: function _startListening() {
      var _this13 = this;
      var t = this.model.document;
      this.listenTo(t.selection, "change:range", function (n, _ref0) {
        var s = _ref0.directChange;
        if (s) {
          if (!t.selection.isCollapsed) {
            _this13.hasMatch && (_this13.fire("unmatched"), _this13._hasMatch = !1);
            return;
          }
          _this13._evaluateTextBeforeSelection("selection");
        }
      }), this.listenTo(t, "change:data", function (n, s) {
        s.isUndo || !s.isLocal || _this13._evaluateTextBeforeSelection("data", {
          batch: s
        });
      });
    }
  }, {
    key: "_evaluateTextBeforeSelection",
    value: function _evaluateTextBeforeSelection(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = this.model,
        i = n.document.selection,
        c = n.createRange(n.createPositionAt(i.focus.parent, 0), i.focus),
        _ye = ye(c, n),
        r = _ye.text,
        l = _ye.range,
        a = this.testCallback(r);
      if (!a && this.hasMatch && this.fire("unmatched"), this._hasMatch = !!a, a) {
        var u = Object.assign(t, {
          text: r,
          range: l
        });
        _typeof(a) == "object" && Object.assign(u, a), this.fire("matched:".concat(e), u);
      }
    }
  }]);
}(V());
var Ie = /*#__PURE__*/function (_k4) {
  function Ie(e) {
    var _this14;
    _classCallCheck(this, Ie);
    _this14 = _callSuper(this, Ie, [e]), _defineProperty(_assertThisInitialized(_this14), "attributes", void 0), _defineProperty(_assertThisInitialized(_this14), "_overrideUid", void 0), _defineProperty(_assertThisInitialized(_this14), "_isNextGravityRestorationSkipped", !1), _this14.attributes = new Set(), _this14._overrideUid = null;
    return _this14;
  }
  _inherits(Ie, _k4);
  return _createClass(Ie, [{
    key: "init",
    value: function init() {
      var _this15 = this;
      var e = this.editor,
        t = e.model,
        n = e.editing.view,
        s = e.locale,
        i = t.document.selection;
      this.listenTo(n.document, "arrowKey", function (c, r) {
        if (!i.isCollapsed || r.shiftKey || r.altKey || r.ctrlKey) return;
        var l = r.keyCode == y.arrowright,
          a = r.keyCode == y.arrowleft;
        if (!l && !a) return;
        var u = s.contentLanguageDirection;
        var d = !1;
        u === "ltr" && l || u === "rtl" && a ? d = _this15._handleForwardMovement(r) : d = _this15._handleBackwardMovement(r), d === !0 && c.stop();
      }, {
        context: "$text",
        priority: "highest"
      }), this.listenTo(i, "change:range", function (c, r) {
        if (_this15._isNextGravityRestorationSkipped) {
          _this15._isNextGravityRestorationSkipped = !1;
          return;
        }
        _this15._isGravityOverridden && (!r.directChange && m(i.getFirstPosition(), _this15.attributes) || _this15._restoreGravity());
      }), this._enableClickingAfterNode(), this._enableInsertContentSelectionAttributesFixer(), this._handleDeleteContentAfterNode();
    }
  }, {
    key: "registerAttribute",
    value: function registerAttribute(e) {
      this.attributes.add(e);
    }
  }, {
    key: "_handleForwardMovement",
    value: function _handleForwardMovement(e) {
      var t = this.attributes,
        n = this.editor.model,
        s = n.document.selection,
        i = s.getFirstPosition();
      return this._isGravityOverridden || i.isAtStart && p(s, t) ? !1 : m(i, t) ? (e && w(e), p(s, t) && m(i, t, !0) ? x(n, t) : this._overrideGravity(), !0) : !1;
    }
  }, {
    key: "_handleBackwardMovement",
    value: function _handleBackwardMovement(e) {
      var t = this.attributes,
        n = this.editor.model,
        s = n.document.selection,
        i = s.getFirstPosition();
      return this._isGravityOverridden ? (e && w(e), this._restoreGravity(), m(i, t, !0) ? x(n, t) : R(n, t, i), !0) : i.isAtStart ? p(s, t) ? (e && w(e), R(n, t, i), !0) : !1 : !p(s, t) && m(i, t, !0) ? (e && w(e), R(n, t, i), !0) : q(i, t) ? i.isAtEnd && !p(s, t) && m(i, t) ? (e && w(e), R(n, t, i), !0) : (this._isNextGravityRestorationSkipped = !0, this._overrideGravity(), !1) : !1;
    }
  }, {
    key: "_enableClickingAfterNode",
    value: function _enableClickingAfterNode() {
      var _this16 = this;
      var e = this.editor,
        t = e.model,
        n = t.document.selection,
        s = e.editing.view.document;
      e.editing.view.addObserver(te), e.editing.view.addObserver(ne);
      var i = !1,
        c = !1;
      this.listenTo(s, "touchstart", function () {
        c = !1, i = !0;
      }), this.listenTo(s, "mousedown", function () {
        c = !0;
      }), this.listenTo(s, "selectionChange", function () {
        var r = _this16.attributes;
        if (!c && !i || (c = !1, i = !1, !n.isCollapsed) || !p(n, r)) return;
        var l = n.getFirstPosition();
        m(l, r) && (l.isAtStart || m(l, r, !0) ? x(t, r) : _this16._isGravityOverridden || _this16._overrideGravity());
      });
    }
  }, {
    key: "_enableInsertContentSelectionAttributesFixer",
    value: function _enableInsertContentSelectionAttributesFixer() {
      var t = this.editor.model,
        n = t.document.selection,
        s = this.attributes;
      this.listenTo(t, "insertContent", function () {
        var i = n.getFirstPosition();
        p(n, s) && m(i, s) && x(t, s);
      }, {
        priority: "low"
      });
    }
  }, {
    key: "_handleDeleteContentAfterNode",
    value: function _handleDeleteContentAfterNode() {
      var _this17 = this;
      var e = this.editor,
        t = e.model,
        n = t.document.selection,
        s = e.editing.view;
      var i = !1,
        c = !1;
      this.listenTo(s.document, "delete", function (r, l) {
        i = l.direction === "backward";
      }, {
        priority: "high"
      }), this.listenTo(t, "deleteContent", function () {
        if (!i) return;
        var r = n.getFirstPosition();
        c = p(n, _this17.attributes) && !q(r, _this17.attributes);
      }, {
        priority: "high"
      }), this.listenTo(t, "deleteContent", function () {
        i && (i = !1, !c && e.model.enqueueChange(function () {
          var r = n.getFirstPosition();
          p(n, _this17.attributes) && m(r, _this17.attributes) && (r.isAtStart || m(r, _this17.attributes, !0) ? x(t, _this17.attributes) : _this17._isGravityOverridden || _this17._overrideGravity());
        }));
      }, {
        priority: "low"
      });
    }
  }, {
    key: "_isGravityOverridden",
    get: function get() {
      return !!this._overrideUid;
    }
  }, {
    key: "_overrideGravity",
    value: function _overrideGravity() {
      this._overrideUid = this.editor.model.change(function (e) {
        return e.overrideSelectionGravity();
      });
    }
  }, {
    key: "_restoreGravity",
    value: function _restoreGravity() {
      var _this18 = this;
      this.editor.model.change(function (e) {
        e.restoreSelectionGravity(_this18._overrideUid), _this18._overrideUid = null;
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "TwoStepCaretMovement";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(k);
function p(o, e) {
  var _iterator5 = _createForOfIteratorHelper(e),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var t = _step5.value;
      if (o.hasAttribute(t)) return !0;
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  return !1;
}
function R(o, e, t) {
  var n = t.nodeBefore;
  o.change(function (s) {
    if (n) {
      var i = [],
        c = o.schema.isObject(n) && o.schema.isInline(n);
      var _iterator6 = _createForOfIteratorHelper(n.getAttributes()),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ref1 = _step6.value;
          var _ref10 = _slicedToArray(_ref1, 2);
          var r = _ref10[0];
          var l = _ref10[1];
          o.schema.checkAttribute("$text", r) && (!c || o.schema.getAttributeProperties(r).copyFromObject !== !1) && i.push([r, l]);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      s.setSelectionAttribute(i);
    } else s.removeSelectionAttribute(e);
  });
}
function x(o, e) {
  o.change(function (t) {
    t.removeSelectionAttribute(e);
  });
}
function w(o) {
  o.preventDefault();
}
function q(o, e) {
  var t = o.getShiftedBy(-1);
  return m(t, e);
}
function m(o, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var n = o.nodeBefore,
    s = o.nodeAfter;
  var _iterator7 = _createForOfIteratorHelper(e),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var i = _step7.value;
      var c = n ? n.getAttribute(i) : void 0,
        r = s ? s.getAttribute(i) : void 0;
      if (!(t && (c === void 0 || r === void 0)) && r !== c) return !0;
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  return !1;
}
var N = {
    copyright: {
      from: "(c)",
      to: "©"
    },
    registeredTrademark: {
      from: "(r)",
      to: "®"
    },
    trademark: {
      from: "(tm)",
      to: "™"
    },
    oneHalf: {
      from: /(^|[^/a-z0-9])(1\/2)([^/a-z0-9])$/i,
      to: [null, "½", null]
    },
    oneThird: {
      from: /(^|[^/a-z0-9])(1\/3)([^/a-z0-9])$/i,
      to: [null, "⅓", null]
    },
    twoThirds: {
      from: /(^|[^/a-z0-9])(2\/3)([^/a-z0-9])$/i,
      to: [null, "⅔", null]
    },
    oneForth: {
      from: /(^|[^/a-z0-9])(1\/4)([^/a-z0-9])$/i,
      to: [null, "¼", null]
    },
    threeQuarters: {
      from: /(^|[^/a-z0-9])(3\/4)([^/a-z0-9])$/i,
      to: [null, "¾", null]
    },
    lessThanOrEqual: {
      from: "<=",
      to: "≤"
    },
    greaterThanOrEqual: {
      from: ">=",
      to: "≥"
    },
    notEqual: {
      from: "!=",
      to: "≠"
    },
    arrowLeft: {
      from: "<-",
      to: "←"
    },
    arrowRight: {
      from: "->",
      to: "→"
    },
    horizontalEllipsis: {
      from: "...",
      to: "…"
    },
    enDash: {
      from: /(^| )(--)( )$/,
      to: [null, "–", null]
    },
    emDash: {
      from: /(^| )(---)( )$/,
      to: [null, "—", null]
    },
    quotesPrimary: {
      from: T('"'),
      to: [null, "“", null, "”"]
    },
    quotesSecondary: {
      from: T("'"),
      to: [null, "‘", null, "’"]
    },
    quotesPrimaryEnGb: {
      from: T("'"),
      to: [null, "‘", null, "’"]
    },
    quotesSecondaryEnGb: {
      from: T('"'),
      to: [null, "“", null, "”"]
    },
    quotesPrimaryPl: {
      from: T('"'),
      to: [null, "„", null, "”"]
    },
    quotesSecondaryPl: {
      from: T("'"),
      to: [null, "‚", null, "’"]
    }
  },
  M = {
    symbols: ["copyright", "registeredTrademark", "trademark"],
    mathematical: ["oneHalf", "oneThird", "twoThirds", "oneForth", "threeQuarters", "lessThanOrEqual", "greaterThanOrEqual", "notEqual", "arrowLeft", "arrowRight"],
    typography: ["horizontalEllipsis", "enDash", "emDash"],
    quotes: ["quotesPrimary", "quotesSecondary"]
  },
  Te = ["symbols", "mathematical", "typography", "quotes"];
var Le = /*#__PURE__*/function (_k5) {
  function Le(e) {
    var _this19;
    _classCallCheck(this, Le);
    _this19 = _callSuper(this, Le, [e]), e.config.define("typing", {
      transformations: {
        include: Te
      }
    });
    return _this19;
  }
  _inherits(Le, _k5);
  return _createClass(Le, [{
    key: "init",
    value: function init() {
      var _this20 = this;
      var t = this.editor.model.document.selection;
      t.on("change:range", function () {
        _this20.isEnabled = !t.anchor.parent.is("element", "codeBlock");
      }), this._enableTransformationWatchers();
    }
  }, {
    key: "_enableTransformationWatchers",
    value: function _enableTransformationWatchers() {
      var e = this.editor,
        t = e.model,
        n = e.plugins.get("Delete"),
        s = Ae(e.config.get("typing.transformations")),
        i = function i(r) {
          var _iterator8 = _createForOfIteratorHelper(s),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var l = _step8.value;
              if (l.from.test(r)) return {
                normalizedTransformation: l
              };
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        },
        c = new Ee(e.model, i);
      c.on("matched:data", function (r, l) {
        if (!l.batch.isTyping) return;
        var _l$normalizedTransfor = l.normalizedTransformation,
          a = _l$normalizedTransfor.from,
          u = _l$normalizedTransfor.to,
          d = a.exec(l.text),
          h = u(d.slice(1)),
          g = l.range;
        var f = d.index;
        t.enqueueChange(function (b) {
          for (var v = 1; v < d.length; v++) {
            var B = d[v],
              O = h[v - 1];
            if (O == null) {
              f += B.length;
              continue;
            }
            var P = g.start.getShiftedBy(f),
              H = t.createRange(P, P.getShiftedBy(B.length)),
              K = we(P);
            t.insertContent(b.createText(O, K), H), f += O.length;
          }
          t.enqueueChange(function () {
            n.requestUndoOnBackspace();
          });
        });
      }), c.bind("isEnabled").to(this);
    }
  }], [{
    key: "requires",
    get: function get() {
      return ["Delete", "Input"];
    }
  }, {
    key: "pluginName",
    get: function get() {
      return "TextTransformation";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(k);
function Ce(o) {
  return typeof o == "string" ? new RegExp("(".concat(oe(o), ")$")) : o;
}
function xe(o) {
  return typeof o == "string" ? function () {
    return [o];
  } : o instanceof Array ? function () {
    return o;
  } : o;
}
function we(o) {
  return (o.textNode ? o.textNode : o.nodeAfter).getAttributes();
}
function T(o) {
  return new RegExp("(^|\\s)(".concat(o, ")([^").concat(o, "]*)(").concat(o, ")$"));
}
function Ae(o) {
  var e = o.extra || [],
    t = o.remove || [],
    n = function n(i) {
      return !t.includes(i);
    },
    s = o.include.concat(e).filter(n);
  return Se(s).filter(n).map(function (i) {
    return typeof i == "string" && N[i] ? N[i] : i;
  }).filter(function (i) {
    return _typeof(i) == "object";
  }).map(function (i) {
    return {
      from: Ce(i.from),
      to: xe(i.to)
    };
  });
}
function Se(o) {
  var e = new Set();
  var _iterator9 = _createForOfIteratorHelper(o),
    _step9;
  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var t = _step9.value;
      if (typeof t == "string" && M[t]) {
        var _iterator0 = _createForOfIteratorHelper(M[t]),
          _step0;
        try {
          for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
            var n = _step0.value;
            e.add(n);
          }
        } catch (err) {
          _iterator0.e(err);
        } finally {
          _iterator0.f();
        }
      } else e.add(t);
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
  return Array.from(e);
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function ke(o, e, t, n) {
  return n.createRange(G(o, e, t, !0, n), G(o, e, t, !1, n));
}
function G(o, e, t, n, s) {
  var i = o.textNode || (n ? o.nodeBefore : o.nodeAfter),
    c = null;
  for (; i && i.getAttribute(e) == t;) c = i, i = n ? i.previousSibling : i.nextSibling;
  return c ? s.createPositionAt(c, n ? "before" : "after") : o;
}
function qe(o, e, t, n) {
  var s = o.editing.view,
    i = new Set();
  s.document.registerPostFixer(function (c) {
    var r = o.model.document.selection;
    var l = !1;
    if (r.hasAttribute(e)) {
      var a = ke(r.getFirstPosition(), e, r.getAttribute(e), o.model),
        u = o.editing.mapper.toViewRange(a);
      var _iterator1 = _createForOfIteratorHelper(u.getItems()),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var d = _step1.value;
          d.is("element", t) && !d.hasClass(n) && (c.addClass(n, d), i.add(d), l = !0);
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
    }
    return l;
  }), o.conversion.for("editingDowncast").add(function (c) {
    c.on("insert", r, {
      priority: "highest"
    }), c.on("remove", r, {
      priority: "highest"
    }), c.on("attribute", r, {
      priority: "highest"
    }), c.on("selection", r, {
      priority: "highest"
    });
    function r() {
      s.change(function (l) {
        var _iterator10 = _createForOfIteratorHelper(i.values()),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var a = _step10.value;
            l.removeClass(n, a), i.delete(a);
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      });
    }
  });
}
export { ve as Delete, ue as Input, ce as InsertTextCommand, Le as TextTransformation, Ee as TextWatcher, Ie as TwoStepCaretMovement, Fe as Typing, ke as findAttributeRange, G as findAttributeRangeBound, ye as getLastTextLine, qe as inlineHighlight };